// Query keys factory for session history queries
export const sessionHistoryKeys = {
  all: ['sessionHistory'] as const,
  lists: () => [...sessionHistoryKeys.all, 'list'] as const,
  list: (userId: string, categoryId?: string, pageSize?: number) =>
    [...sessionHistoryKeys.lists(), userId, categoryId, pageSize] as const,
  favorites: (userId: string) =>
    [...sessionHistoryKeys.all, 'favorites', userId] as const,
};